import { render, staticRenderFns } from "./DetailsReinsurer.vue?vue&type=template&id=2e479bdc&scoped=true&"
import script from "./DetailsReinsurer.vue?vue&type=script&lang=js&"
export * from "./DetailsReinsurer.vue?vue&type=script&lang=js&"
import style0 from "./DetailsReinsurer.vue?vue&type=style&index=0&id=2e479bdc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e479bdc",
  null
  
)

export default component.exports